import React from 'react';
import './ButtonPlay.css';

const ButtonPlay = (props) => {
  
    const onClickLocal = (e) => {
      e.stopPropagation();
      props.onClick();
    };
  
    return (
      <button className="button-play" onClick={onClickLocal}>
       
       <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      version="1.1"
      viewBox="0 0 180 180"
      xmlSpace="preserve"
    >
      <path
        fill="#EEE"
        stroke="#EEE"
        d="M132.8 92L67.9 129.5 3 167 3 92 3 17 67.9 54.5z"
      ></path>
      <path fill="none" d="M0 0H180V180H0z"></path>
    </svg>
</button>
  )
}

export default ButtonPlay;


// const ButtonPlay = ({onPlayerClick}) => {
//   return (
//       <svg className="button-play" viewBox="0 0 60 60" onClick={onPlayerClick}>
//         <polygon points="0,0 50,30 0,60" />
//       </svg>
//   )
// }